import React from 'react'
import {
  Table,
  Button,
  Popup
} from 'semantic-ui-react'
import {
  Link,
} from 'react-router-dom'

const OptionalSelectTableHeaderCell = ({mode, selection}) => {
  if (mode==='select') {
    return (
      <Table.HeaderCell collapsing textAlign='center'>
        {
          selection
          ?
          <Popup trigger={
            <Button fluid compact color='orange' as={Link} to={'/selection/'+selection.id}>
              {selection.id}
            </Button>
          } content={
            <span>
              <strong>{selection.name}</strong><br/>
              {selection.author}
            </span>
          }/>
          :
          "Select"
        }
      </Table.HeaderCell>
    );
  } else {
    return null;
  }
}

export default OptionalSelectTableHeaderCell